export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            欢迎提供吃瓜线索、爆料投稿或商务合作，51吃瓜网站期待你的参与
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100 text-primary-600">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">投稿爆料</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              如果你有独家吃瓜线索或黑料素材，欢迎通过邮件发送给我们，一经采用即付稿酬。
            </p>
            <p className="mt-3 text-sm text-primary-600 font-medium">tips@51chigua.com</p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-accent-200/60 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-100 text-accent-600">
              <i className="ri-briefcase-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              品牌推广、广告投放、内容合作等商务需求，请与我们的市场团队联系洽谈。
            </p>
            <p className="mt-3 text-sm text-accent-600 font-medium">biz@51chigua.com</p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-secondary-200/60 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-question-answer-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">意见反馈</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              如果你对51吃瓜网站有任何建议或遇到使用问题，欢迎随时向我们反馈，我们会尽快处理。
            </p>
            <p className="mt-3 text-sm text-secondary-600 font-medium">feedback@51chigua.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}